import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './assets/main.css'

import { projectAuth } from './firebase/firebase';


let app

projectAuth.onAuthStateChanged(() => {
    if (!app) {        
        app = createApp(App)
        .use(router)
        .mount('#app')
    }
})


